import {
    Box,
    Stack,
    Typography,
    IconButton,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { useApiService } from "../../../../../services/ApiService/ApiService";

interface UploadProgressTableProps {
    incompleteFiles: any[];
    userInfo: {
        uuid: string;
        fleetUuid: string;
    };
    statusPolling: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}

function UploadProgressTable(props: UploadProgressTableProps) {
    const { incompleteFiles, userInfo, statusPolling } = props;
    const [isError, setIsError] = useState(false);
    const { fetchWithAuth } = useApiService();

    function deleteVehicle(iceVehicle: any) {
        let bodyData: { [name: string]: any } = {};
        bodyData["uuid"] = userInfo.uuid;
        bodyData["fleetUuid"] = userInfo.fleetUuid;
        bodyData["iceVehicle"] = iceVehicle;

        try {
            fetchWithAuth('/DragDrop/fleet/icevehicle/delete', {
                method: "POST",
                body: JSON.stringify(bodyData),
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                })
                .catch(() => {
                    setIsError(true);
                });
        } catch {
            setIsError(true);
        }
    }

    const columns: GridColDef[] = [
        {
            field: "originalFilename",
            headerName: "File Name",
            sortable: false,
            width: 200,

        },
        {
            field: "statusDisplayName",
            headerName: "Status",
            sortable: false,
            width: 150,

        },
        {
            field: "loadedVehicles",
            headerName: "Loaded Vehicles",
            sortable: false,
            width: 200,

        },
        {
            field: "totalVehicles",
            headerName: "Total Vehicles",
            sortable: false,
            width: 200,

        },
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            width: 100,

            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <IconButton
                        size="small"
                        onClick={() => deleteVehicle(params.row)}
                        color="error"
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Stack>
            ),
        },
    ];

    return (
        <DataGrid
            rows={incompleteFiles}
            columns={columns}
            disableRowSelectionOnClick
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            disableDensitySelector
            initialState={{
                pagination: {
                    paginationModel: { pageSize: 10 },
                },
            }}
            pageSizeOptions={[10, 25, 50]}
            sx={{
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'background.paper',
                    borderBottom: 1,
                    borderColor: 'divider',
                },
                '& .MuiDataGrid-cell': {
                    borderBottom: 1,
                    borderColor: 'divider',
                },
                '& .MuiDataGrid-row:hover': {
                    backgroundColor: 'action.hover',
                },
            }}
        />
    );
}

export default UploadProgressTable;
